import React from 'react'
import { useTheme } from '@material-ui/core'
import {
  Datagrid,
  Filter,
  FunctionField,
  ListProps,
  Pagination,
  sanitizeFetchType,
  TextField,
  TextInput,
  useQuery,
  useTranslate,
} from 'react-admin'
import { ResourceName } from '../../../../core/ResourceName'
import List from '../../../common/customized-ra-components/List'
import FilterProps from '../../../common/FilterProps'
import {
  CheckCameraServerError,
  CheckLastRefreshError,
} from '../../common/modules/ModuleStatus'
import { CameraTypes } from '../../../../core/enum/CameraTypes'
import { CameraServerStatusDto } from '../../../../core/dto/device/camera/camera-servers/camera-server.dto-status'
import { cameraServerTypesAbleToBeVerified } from '../../../../core/constants/cameraServerTypesAbleToBeVerified'
import { useColorPalette } from '../../../../core/devices/devices.utils'
import { DeviceStatusCheck } from '../../../../core/enum/DeviceStatusCheck'

const CameraServerFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

export const CameraServerList = ({ ...props }: ListProps) => {
  const translate = useTranslate()
  const theme = useTheme()
  const colorPalette = useColorPalette(theme)

  const { data: serverDate } = useQuery({
    type: sanitizeFetchType('getServerDateTime'),
    resource: ResourceName.CURRENT_USER,
    payload: {},
  })

  const postRowStyle = (record: any) => {
    if (
      !serverDate ||
      !cameraServerTypesAbleToBeVerified.includes(record.type)
    ) {
      return {}
    }

    const cameraServerError = CheckLastRefreshError(
      record?.lastRefresh,
      serverDate?.serverDateTime,
    )
    if (cameraServerError) return colorPalette(DeviceStatusCheck.ERROR)

    const cameraServerWarning = CheckCameraServerError(
      JSON.parse(record.jsonStatus) as CameraServerStatusDto,
      record.type as CameraTypes,
    )
    if (cameraServerWarning) return colorPalette(DeviceStatusCheck.WARNING)
    return colorPalette(DeviceStatusCheck.SUCCESS)
  }

  return (
    <List
      {...props}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      exporter={false}
      sort={{
        field: 'id',
        order: 'DESC',
      }}
      filters={<CameraServerFilters />}
      bulkActionButtons={false}
    >
      <Datagrid
        rowStyle={postRowStyle}
        size="small"
        rowClick={(id) => `${ResourceName.CAMERA_SERVERS}/${id}/show`}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="address" />
        <FunctionField
          source="type"
          render={(record) =>
            translate(`resources.enums.CameraTypes.${record?.type}`)
          }
        />
      </Datagrid>
    </List>
  )
}
